import getInstanceAxios from '../Request';

const baseDomain = process.env.REACT_APP_DISCOVER;
const baseURL = `${baseDomain}/`;

export default getInstanceAxios(baseURL);
